import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ProductShowcase from './components/ProductShowcase';
import FeaturesSection from './components/FeaturesSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ProductShowcase />
        <FeaturesSection />
        <ArticleSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}